module.exports = __webpack_public_path__ + "static/media/chat.3b4da151.png";